export const iconFontAwesomeMarketingFishFins = (
	<i className="fa-solid fa-fish-fins"></i>
);
